import { uatob } from "./uatob";
import { CRC32 } from "./CRC32";

export function CheckDL(deeplink) {
  var dlinfo = uatob(deeplink);
  var length = dlinfo.length;
  var crcIndex = dlinfo.indexOf("crc=");
  if (crcIndex == -1) return null;

  var crcA = dlinfo.substring(crcIndex + 4, length);
  dlinfo = dlinfo.substring(0, crcIndex - 1);
  var crcB = CRC32.str(dlinfo);

  if (crcA != crcB) {
    //crcA is their checksum
    var crcC = parseInt(crcA) - 4294967296;
    if (crcB != crcC) return null;
  }
  return dlinfo;
}
